import type {TeamMember, TeamMemberData} from '../member';

export interface TeamServiceResponse {
	members: TeamMemberData[];
}

export abstract class TeamGrid {
	public members!: TeamMember[];
	public readonly elements = {
		main: document.querySelector('#container > main') as HTMLElement,
		container: document.querySelector('#container > main > section') as HTMLElement,
		section: document.createElement('section'),
		content: document.createElement('div'),
		header: document.createElement('header'),
		heading: document.createElement('h2'),
		grid: document.createElement('ul')
	} as const;

	public abstract load(): Promise<void>;

	constructor() {
		this.elements.main.append(this.elements.section);
		this.elements.section.append(this.elements.content);
		this.elements.content.append(this.elements.header, this.elements.grid);
		this.elements.header.append(this.elements.heading);
		this.elements.content.classList.add('content');
		this.elements.grid.classList.add('grid');
		this.elements.grid.id = 'team-grid';
	}
}
